const parseSetCount = (setsValue) => {
  if (Number.isFinite(setsValue)) {
    return Math.max(1, Math.round(setsValue));
  }
  const match = String(setsValue || '').match(/\d+/);
  return match ? Math.max(1, parseInt(match[0], 10)) : 1;
};

export const resolvePreferredWeightUnit = (user) => {
  const preferredUnits =
    user?.profileData?.profile?.equipmentAndPreferences?.preferredUnits ||
    user?.profileData?.equipmentAndPreferences?.preferredUnits ||
    'metric';

  return preferredUnits === 'imperial' ? 'lb' : 'kg';
};

export const buildWorkoutPerformanceDraft = (quest, weightUnit = 'kg') => {
  const exercises = Array.isArray(quest?.detailedDescription?.exercises)
    ? quest.detailedDescription.exercises
    : [];

  return {
    version: 1,
    questId: quest?._id || null,
    weightUnit,
    exercises: exercises.map((exercise, exerciseIndex) => {
      const targetSets = parseSetCount(exercise?.sets);
      return {
        exerciseIndex,
        name: exercise?.name || `Exercise ${exerciseIndex + 1}`,
        targetSets,
        targetReps: exercise?.reps || '',
        plannedSuggestedWeight: exercise?.suggestedWeight || '',
        sets: Array.from({ length: targetSets }, (_, setIndex) => ({
          setNumber: setIndex + 1,
          targetReps: exercise?.reps || '',
          actualReps: '',
          actualWeight: '',
          weightUnit,
        })),
      };
    }),
  };
};

export const mergeWorkoutPerformanceDraft = (savedDraft, quest, weightUnit = 'kg') => {
  const baseDraft = buildWorkoutPerformanceDraft(quest, weightUnit);
  if (!savedDraft || !Array.isArray(savedDraft.exercises)) {
    return baseDraft;
  }

  return {
    ...baseDraft,
    exercises: baseDraft.exercises.map((exercise) => {
      const savedExercise = savedDraft.exercises.find(
        (candidate) => candidate?.exerciseIndex === exercise.exerciseIndex
          || candidate?.name === exercise.name
      );

      if (!savedExercise || !Array.isArray(savedExercise.sets)) {
        return exercise;
      }

      return {
        ...exercise,
        sets: exercise.sets.map((set) => {
          const savedSet = savedExercise.sets.find((candidate) => candidate?.setNumber === set.setNumber);
          if (!savedSet) return set;
          return {
            ...set,
            actualReps: savedSet.actualReps ?? '',
            actualWeight: savedSet.actualWeight ?? '',
            weightUnit: savedSet.weightUnit || weightUnit,
          };
        }),
      };
    }),
  };
};

export const updateWorkoutPerformanceSet = (draft, exerciseIndex, setNumber, patch) => {
  if (!draft || !Array.isArray(draft.exercises)) {
    return draft;
  }

  return {
    ...draft,
    exercises: draft.exercises.map((exercise) => {
      if (exercise.exerciseIndex !== exerciseIndex) {
        return exercise;
      }

      return {
        ...exercise,
        sets: exercise.sets.map((set) => {
          if (set.setNumber !== setNumber) {
            return set;
          }
          return { ...set, ...patch };
        }),
      };
    }),
  };
};

export const hasWorkoutPerformanceEntries = (draft) => {
  if (!draft || !Array.isArray(draft.exercises)) {
    return false;
  }

  return draft.exercises.some((exercise) => (
    Array.isArray(exercise.sets) && exercise.sets.some((set) => (
      String(set.actualReps || '').trim() || String(set.actualWeight || '').trim()
    ))
  ));
};
